module.exports = __webpack_public_path__ + "static/media/icon-match.df376635.png";